export default __webpack_public_path__ + "static/media/left_portal_mobile.14750651.png";